import React from 'react';
import Header from '../../Shared/Header';
import BreadCums from '../../Shared/BreadCums';
import PrivacyDetails from './PrivacyDetails';
import Footer3 from '../../Shared/Footer3';

const Privacy = () => {
    return (
        <>
            <Header
                parentMenu='pages'
                headerClass='sc-header-section inner-header-style'
                signUpBtn='inner-btn'
            />
            <BreadCums pageTitle='Privacy Policy' />
            <PrivacyDetails />
            <Footer3 />
        </>
    );
};

export default Privacy;
